import { ThemeUICSSObject, spacing } from '@apia/theme';

const footerResponsiveButtons: ThemeUICSSObject = {
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  p: spacing(3),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: spacing(3),
  background: 'palette.background.paper',
  borderTop: '1px solid',
  borderTopColor: 'palette.border.field',
  zIndex: 'menu',
  transition: 'bottom 0.3s',

  '&.hidden': {
    bottom: '-100px',
  },
};

export default footerResponsiveButtons;
